<!-- <h1>Portfolio Number {{portfolioNumber}}</h1> -->
<div class="d-flex flex-row flex-wrap justify-content-start align-items-start white_graph p-3">
    <div class="position-relative d-block w-100 pb-2">Overview</div>
    <a [routerLink]="[]" [relativeTo]="route" fragment="{{(idx+1)}}" *ngFor="let chart of charts;let idx = index">
      <app-chart-thumbnail *ngIf="chart.url==null && chart.href==null" [style]="{'float':'none','display':'block','min-height':'110px','height':'110px'}" [imgStyle]="null" [chart]="chart"
        [index]="(idx+1).toString()" [permalink]="false"></app-chart-thumbnail>
    </a>
    <a routerLink="/index-calculator" class=" d-flex flex-column justify-content-center align-items-center mx-2">
      <div  
      style="border-radius: 50%;
      border-width: 3.75px;
      border-style: solid; 
      border-color:rgb(93, 71, 110); 
      width:75px; 
      height:75px;
      background-color: rgb(100, 100, 100);
      background-image:url('/images/calculator.svg'); 
      background-size: 50px 50px; 
      background-position: center; 
      background-repeat: no-repeat;
      ">  
      </div>
      <span class="d-block" style="font-size: 12px;">Index Calculator</span>
    </a>
  </div>
  <div class="otherCharts d-flex flex-row flex-wrap justify-content-start align-items-start white_graph ms-2">

  <ng-container *ngFor="let chart of charts">      
      <ng-container *ngIf="chart.url">
        <a [routerLink]="chart.url"  style="margin-left:2px" >
          <app-chart-thumbnail *ngIf="chart.url!=null" [style]="{'min-height':'100px','height':'100px'}"
            [imgStyle]="null" [chart]="chart" [permalink]="false"></app-chart-thumbnail>
        </a>      
      </ng-container>
      <ng-container *ngIf="chart.href">
        <a href="{{chart.href}}" target="{{chart.target}}" style="margin-left:2px">
          <app-chart-thumbnail *ngIf="chart.href!=null" [style]="{'min-height':'100px','height':'100px'}"
            [imgStyle]="null" [chart]="chart" [permalink]="false"></app-chart-thumbnail>
        </a>
      </ng-container>  
  </ng-container> 

  


  </div>